import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OperationModeBuilder } from '../../models/builders/operation-mode.builder';
import { getErrorHandlingOptions } from '../base/headers';
import { OperationMode } from '../../models/operation-mode';

const operationModeBody = (operationMode: OperationMode) => ({
  name: operationMode.name
});

@Injectable()
export class OperationModeApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }operationModes`;
  }

  getOperationModes() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(OperationModeBuilder.fromList)
      );
  }

  getOperationMode(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(OperationModeBuilder.fromJson)
      );
  }

  createOperationMode(operationMode) {
    return this.httpClient.post(this.apiUrl, operationModeBody(operationMode)).pipe(map(OperationModeBuilder.fromJson));
  }

  updateOperationMode(operationMode: OperationMode) {
    return this.httpClient.put(`${ this.apiUrl }/${ operationMode.hash }`, operationModeBody(operationMode));
  }

  deleteOperationMode(operationMode: OperationMode) {
    return this.httpClient.delete(`${ this.apiUrl }/${ operationMode.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/operation-mode-api.service.ts